import type { SerialisedEditorDesign } from "../message/editor/types/serialised-editor-design";

export const makeDefaultLexicalDesign = (
  type: "email" | "chat" | "sms",
  defaultText?: string | null,
  companyName?: string | null,
): SerialisedEditorDesign => {
  if (type === "chat") {
    return {
      root: {
        type: "root",
        format: "",
        indent: 0,
        version: 1,
        children: [
          {
            type: "paragraph",
            format: "",
            indent: 0,
            version: 1,
            children: [
              {
                mode: "normal",
                text: "Insert a Title here",
                type: "text",
                style: "",
                detail: 0,
                format: 1,
                version: 1,
              },
            ],
            direction: "ltr",
          },
          {
            url: "https://images.changeengine.com/Placeholder-image-400.png",
            type: "image",
            aspect: 1,
            format: "",
            version: 2,
            proportionOfMaxWidth: 0.6666666666666666,
          },
          {
            type: "paragraph",
            format: "",
            indent: 0,
            version: 1,
            children: [
              {
                mode: "normal",
                text: "Hi [Add Merge Tag Here],",
                type: "text",
                style: "",
                detail: 0,
                format: 0,
                version: 1,
              },
            ],
            direction: "ltr",
          },
          {
            type: "paragraph",
            format: "",
            indent: 0,
            version: 1,
            children: [
              {
                mode: "normal",
                text: "Add your body text here, include links, lists, merge tags and more!",
                type: "text",
                style: "",
                detail: 0,
                format: 0,
                version: 1,
              },
            ],
            direction: "ltr",
          },
          {
            type: "buttonlist",
            format: "",
            buttons: [
              {
                id: "fe422f11-6d9a-4282-a5b9-3fdd30a47fd7",
                url: "https://www.example.com",
                text: "Button Text",
              },
            ],
            version: 1,
          },
          {
            type: "paragraph",
            format: "",
            indent: 0,
            version: 1,
            children: [
              {
                mode: "normal",
                text: "Best Regards,",
                type: "text",
                style: "",
                detail: 0,
                format: 0,
                version: 1,
              },
            ],
            direction: "ltr",
          },
          {
            type: "paragraph",
            format: "",
            indent: 0,
            version: 1,
            children: [
              {
                tag: "company_name",
                mode: "token",
                text: "company_name",
                type: "merge-tag-v2",
                style: "",
                detail: 1,
                format: 0,
                version: 1,
              },
              {
                mode: "normal",
                text: " People Team",
                type: "text",
                style: "",
                detail: 0,
                format: 0,
                version: 1,
              },
            ],
            direction: "ltr",
          },
        ],
        direction: "ltr",
      },
    } as unknown as SerialisedEditorDesign;
  }

  if (type === "email") {
    return {
      root: {
        type: "root",
        format: "",
        indent: 0,
        version: 1,
        children: [
          {
            tag: "h1",
            type: "heading",
            format: "",
            indent: 0,
            version: 1,
            children: [
              {
                mode: "normal",
                text: "Insert a Title here",
                type: "text",
                style: "",
                detail: 0,
                format: 0,
                version: 1,
              },
            ],
            direction: "ltr",
          },
          {
            url: "https://images.changeengine.com/Placeholder-image-400.png",
            type: "image",
            aspect: 1,
            format: "",
            version: 2,
            proportionOfMaxWidth: 0.6666666666666666,
          },
          {
            type: "paragraph",
            format: "",
            indent: 0,
            version: 1,
            children: [
              {
                mode: "normal",
                text: "Hi [Add Merge Tag Here],",
                type: "text",
                style: "",
                detail: 0,
                format: 0,
                version: 1,
              },
            ],
            direction: "ltr",
          },
          {
            type: "paragraph",
            format: "",
            indent: 0,
            version: 1,
            children: [
              {
                mode: "normal",
                text: "Add your body text here, include links, lists, merge tags and more!",
                type: "text",
                style: "",
                detail: 0,
                format: 0,
                version: 1,
              },
            ],
            direction: "ltr",
          },
          {
            url: "https://www.example.com",
            text: "Button Text",
            type: "styleablebutton",
            format: "left",
            version: 1,
            fullWidth: true,
            buttonType: "primary_button",
          },
          {
            type: "paragraph",
            format: "",
            indent: 0,
            version: 1,
            children: [
              {
                mode: "normal",
                text: "Best Regards,",
                type: "text",
                style: "",
                detail: 0,
                format: 0,
                version: 1,
              },
            ],
            direction: "ltr",
          },
          {
            type: "paragraph",
            format: "",
            indent: 0,
            version: 1,
            children: [
              {
                tag: "company_name",
                mode: "token",
                text: "company_name",
                type: "merge-tag-v2",
                style: "",
                detail: 1,
                format: 0,
                version: 1,
              },
              {
                mode: "normal",
                text: " People Team",
                type: "text",
                style: "",
                detail: 0,
                format: 0,
                version: 1,
              },
            ],
            direction: "ltr",
          },
        ],
        direction: "ltr",
      },
    } as unknown as SerialisedEditorDesign;
  }

  return {
    root: {
      type: "root",
      format: "",
      indent: 0,
      version: 1,
      children: [
        {
          type: "paragraph",
          format: "",
          indent: 0,
          version: 1,
          children: [
            ...(!defaultText && !companyName
              ? [
                  {
                    mode: "normal",
                    text: "Insert a Title here",
                    type: "text",
                    style: "",
                    detail: 0,
                    format: 0,
                    version: 1,
                  },
                ]
              : []),
            ...(companyName
              ? [
                  {
                    mode: "normal",
                    text: `${companyName}: `,
                    type: "text",
                    style: "",
                    detail: 0,
                    format: 0,
                    version: 1,
                  },
                ]
              : []),
            ...(defaultText
              ? [
                  {
                    type: "linebreak",
                    version: 1,
                  },
                  {
                    type: "linebreak",
                    version: 1,
                  },
                  {
                    mode: "normal",
                    text: defaultText,
                    type: "text",
                    style: "",
                    detail: 0,
                    format: 0,
                    version: 1,
                  },
                ]
              : []),
          ],
          direction: "ltr",
        },
      ],
    },
  } as unknown as SerialisedEditorDesign;
};
